import { useState } from "react";
import { useRecoilState } from "recoil";

import { recoilStates } from "src/recoil/recoilStates";

import styled from "styled-components";

import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useRefetchBookings } from "src/hooks";
import AlertModal from "src/components/YearBooking/components/common/AlertModal";
import RoundDateSelector from "src/components/YearBooking/components/common/RoundDateSelector";
import checkCircle from "../assets/images/check_circle.svg";
import checkCircleOff from "../assets/images/check_circle-off.svg";

export default function RoundPayments() {
  const navigate = useNavigate();

  const [group, setGroup] = useRecoilState(recoilStates.group);

  const refetchBookings = useRefetchBookings();

  const [bookingApplication, setBookingApplication] = useRecoilState(
    recoilStates.bookingApplication
  );

  // AlertModal 상태 관리
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // 체크박스 상태 관리
  const [isAgreementChecked, setIsAgreementChecked] = useState(false);

  const clubRelData = bookingApplication?.clubRels?.find((cr) =>
    [4, 6].includes(cr.year_booking_status_id)
  );
  const rounds = clubRelData?.year_booking_round_dates;

  const [activeDateIds, setActiveDateIds] = useState<number[]>([
    rounds
      ?.filter((r) => {
        return new Date(new Date(r.round_date).getTime() + 86400 * 1000) > new Date();
      })
      .reduce((acc, curr) => {
        if (new Date(curr.round_date) < new Date(acc.round_date)) {
          return curr;
        }
        return acc;
      })?.id || 0,
  ]);

  const selected = rounds?.find((r) => r.id === activeDateIds?.[0]);

  const handleCallKgCard2 = (itemCodeInsert?: string) => {
    console.log("itemCodeInsert :", itemCodeInsert);
    (async () => {
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_TEESHOT_SERVER_URL}/kgMob/credit/callPaymentWindow?callType=I`,
          {
            token: localStorage?.getItem("auth-token"),
            itemCode: itemCodeInsert ?? "",
            paymentEndBackUrl: `${process.env.REACT_APP_DOMAIN}/year-booking`,
            cancelUrl: `${process.env.REACT_APP_TEESHOT_SERVER_URL}/kgMob/cancel`,
            additionalNoti: {
              key: "yearBookingRound",
              param: { roundId: selected?.id, itemCodeInsert },
            },
          }
        );
        if (!res.data.success) {
          console.log("res?.data?.message :", res?.data?.message);
          console.log("res?.data :", res?.data);
          throw new Error(res?.data?.message || "결제 불러오기 오류");
        }

        navigate("/kgController", { state: { htmlToShow: res.data.data } });
      } catch (e) {
        console.log("e :", e);
        setErrorMessage(e instanceof Error ? e.message : "결제 불러오기 오류");
        setShowErrorModal(true);
      }
    })();
  };

  const selectedRound = rounds?.find((r) => r.id === activeDateIds?.[0]);
  console.log("selectedRound :", selectedRound);
  const feeAmount = selectedRound?.teams?.length ? selectedRound.teams.length * 10000 : 0;

  return (
    <>
      <StyledPage className="fee-payment-page">
        {/* Warning Message */}
        <div className="warning-message">
          <div className="warning-text">라운드 5일전까지 연단체 이용 수수료를 납부해주세요.</div>
        </div>

        {/* Round Date Section */}
        <RoundDateSelector
          selectedRound={selectedRound}
          rounds={rounds || []}
          onDateSelect={(roundId) => {
            // 선택된 라운드 ID로 activeDateIds 업데이트
            setActiveDateIds([roundId]);
          }}
        />

        {/* Fee Section */}
        <div className="fee-section">
          <div className="fee-header">
            <span className="fee-label">이용 수수료</span>
            <span className="fee-note">*골프장 상황에 따라 변동</span>
          </div>
          <div className="fee-box">
            <div className="fee-row total">
              <span className="fee-type">총 결제 금액</span>
              <span className="fee-amount orange">{feeAmount.toLocaleString()} 원</span>
            </div>
            <div className="fee-row usage">
              <span className="fee-type">골프장 매칭 수수료</span>
              <span className="fee-amount">0 원</span>
            </div>
            <div className="fee-row usage">
              <span className="fee-type">이용 수수료 (팀당 1만원)</span>
              <span className="fee-amount">{feeAmount.toLocaleString()} 원</span>
            </div>
          </div>
        </div>
        {/* Terms Box */}
        <div className="terms-box">
          <div className="terms-text">
            *이용 수수료는 팀당 1만원이며, 수수료를 납부해야 락커번호가 부여되며, 이는 라운드 운영
            및 서비스 개선을 위해 사용됩니다.
            <br />
            <br />
            *본 이용 수수료는 결제일로부터 7일 이내 청약 철회가 가능하며, 환불 요청시 예약이
            취소됩니다.
          </div>
        </div>
        <div className="divider"></div>

        {/* Agreement Section */}
        <div className="agreement-main">
          <div className="checkbox" onClick={() => setIsAgreementChecked(!isAgreementChecked)}>
            <img
              src={isAgreementChecked ? checkCircle : checkCircleOff}
              alt={isAgreementChecked ? "checked" : "unchecked"}
            />
          </div>
          <div className="agreement-text">티샷 위약 규정과 서비스 개인정보 이용 전체 동의</div>
        </div>

        {/* <div className="disclaimer">
          티샷은 월단체 부킹에 대한 통신판매중개자이며, 예약과 취소 거래에 대한 어떠한 책임을 지지
          않습니다.
        </div> */}

        <div className="agreement-details">
          <div
            className="agreement-item"
            onClick={() => navigate("/year-booking/cancellation-policy")}
            style={{ cursor: "pointer" }}
          >
            <div className="item-content">
              <span className="required" style={{ marginRight: "4px" }}>
                [필수]
              </span>
              골프장 취소/위약규정 동의
            </div>
            <svg width="7" height="10" viewBox="0 0 7 10" fill="none">
              <path
                d="M4.50008 5L0.666748 1.16667L1.83341 0L6.83341 5L1.83341 10L0.666748 8.33333L4.50008 5Z"
                fill="#79818A"
              />
            </svg>
          </div>
          <div
            className="agreement-item"
            onClick={() => navigate("/year-booking/privacy-consent")}
            style={{ cursor: "pointer" }}
          >
            <div className="item-content">
              <span className="required" style={{ marginRight: "4px" }}>
                [필수]
              </span>
              개인정보 제3자 제공 동의
            </div>
            <svg width="7" height="10" viewBox="0 0 7 10" fill="none">
              <path
                d="M4.50008 5L0.666748 1.16667L1.83341 0L6.83341 5L1.83341 10L0.666748 8.33333L4.50008 5Z"
                fill="#79818A"
              />
            </svg>
          </div>
        </div>

        {/* Bottom Payment Button */}
        <div className="bottom-section">
          {selectedRound?.teams?.length ? (
            selectedRound.is_paid ? (
              <div className="payment-completed">
                <span className="completed-text">결제완료</span>
              </div>
            ) : (
              <div
                className={`payment-button ${!isAgreementChecked ? "disabled" : ""}`}
                onClick={() => {
                  if (isAgreementChecked) {
                    handleCallKgCard2(`round-fee-${selectedRound.teams?.length ?? "0"}`);
                  }
                }}
              >
                <span className="button-text">수수료 납부하기</span>
              </div>
            )
          ) : (
            <div className="payment-disabled">
              <span className="disabled-text">조 편성을 먼저 진행해 주세요.</span>
            </div>
          )}
        </div>
      </StyledPage>

      {/* AlertModals */}
      {showErrorModal && (
        <AlertModal
          onClose={() => setShowErrorModal(false)}
          title="결제 오류"
          subtitle={errorMessage}
          lines={["잠시 후 다시 시도해주세요."]}
          confirmText="확인"
          onConfirm={() => setShowErrorModal(false)}
        />
      )}
    </>
  );
}

const StyledPage = styled.div`
  width: 100%;
  background: var(--teeshot-white, #fdfdfd);
  font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
  margin: 0 auto;
  padding: 20px 16px 120px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  /* Warning Message */
  .warning-message {
    display: flex;
    padding: 8px 12px;
    align-items: center;
    border-radius: 6px;
    background: var(--teeshot-negative-white, #ffeded);
    margin-bottom: 8px;
  }

  .warning-text {
    color: var(--teeshot-negative, #ff4949);
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
  }

  /* Round Date Section */
  .round-date-label {
    color: var(--teeshot-black, #1a1a1a);
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    margin-bottom: 8px;
  }

  .date-input {
    display: flex;
    width: 100%;
    height: 44px;
    padding: 12px 10px;
    justify-content: space-between;
    align-items: center;
    border-radius: 6px;
    border: 1px solid var(--teeshot-g2, #d1d5d8);
    background: var(--teeshot-white, #fdfdfd);
    cursor: pointer;
    margin-bottom: 16px;
  }

  .date-text {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
  }

  .date-main {
    color: var(--teeshot-black, #1a1a1a);
    font-weight: 700;
    font-size: 14px;
  }

  .payment-status {
    color: var(--teeshot-negative, #ff4949);
    font-weight: 700;
    font-size: 12px;
  }

  .dropdown-icon {
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  /* Dividers */
  .divider {
    width: 100%;
    height: 1px;
    background: var(--teeshot-g2, #d1d5d8);
    margin: 16px 0;
  }

  /* Fee Section */
  .fee-section {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .fee-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .fee-label {
    color: var(--teeshot-black, #1a1a1a);
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
  }

  .fee-note {
    color: var(--teeshot-g1, #79818a);
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
  }

  .fee-box {
    width: 100%;
    padding: 16px;
    border-radius: 6px;
    background: var(--teeshot-g3, #f0f0f4);
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .fee-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .fee-type {
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
  }

  .fee-row.total .fee-type {
    color: var(--teeshot-yellow, #f97000);
  }

  .fee-row.usage .fee-type {
    color: var(--teeshot-black, #1a1a1a);
  }

  .fee-amount {
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    text-align: right;
    color: var(--teeshot-black, #1a1a1a);
  }

  .fee-amount.orange {
    color: var(--teeshot-yellow, #f97000);
  }

  /* Agreement Section */
  .agreement-main {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .checkbox {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .checkbox img {
    width: 24px;
    height: 24px;
  }

  .agreement-text {
    color: var(--teeshot-black, #1a1a1a);
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
  }

  .disclaimer {
    color: var(--teeshot-black, #1a1a1a);
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
    margin-bottom: 16px;
  }

  .agreement-details {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 20px;
  }

  .agreement-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: var(--teeshot-black, #1a1a1a);
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
  }

  .item-content {
    display: flex;
    align-items: center;
  }

  .required {
    color: #007bff;
  }

  /* Terms Box */
  .terms-box {
    display: flex;
    width: 100%;
    padding: 12px;
    border-radius: 6px;
    background: var(--teeshot-g3, #f0f0f4);
  }

  .terms-text {
    color: var(--teeshot-g1, #79818a);
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
  }

  /* Bottom Section */
  .bottom-section {
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    padding: 26px 16px;
    background: linear-gradient(
      0deg,
      var(--teeshot-white, #fdfdfd) 76.92%,
      rgba(253, 253, 253, 0) 100%
    );
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .payment-button {
    display: flex;
    width: 100%;
    max-width: 358px;
    height: 60px;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    background: var(--teeshot-green, #004b49);
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .payment-button:hover:not(.disabled) {
    opacity: 0.9;
  }

  .payment-button.disabled {
    background: var(--teeshot-g2, #d1d5d8);
    cursor: not-allowed;
  }

  .payment-button.disabled .button-text {
    color: var(--teeshot-g1, #79818a);
  }

  .button-text {
    color: var(--teeshot-white, #fdfdfd);
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    line-height: 22px;
  }

  .payment-completed {
    display: flex;
    width: 100%;
    max-width: 358px;
    height: 60px;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    background: var(--teeshot-g2, #d1d5d8);
  }

  .completed-text {
    color: var(--teeshot-g1, #79818a);
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    line-height: 22px;
  }

  .payment-disabled {
    display: flex;
    width: 100%;
    max-width: 358px;
    height: 60px;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    background: var(--teeshot-g2, #d1d5d8);
  }

  .disabled-text {
    color: var(--teeshot-g1, #79818a);
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
  }
`;
